// modules/land-for-sale/elements/PlanDisplay.js
import React        from 'react';

class planDisplay extends React.Component {
    constructor(props) {
        super(props);

        this.renderCircles = this.renderCircles.bind(this);
    }
    renderCircles(element) {
        let svgclass;
        switch(element.status) {
            case 1:
                svgclass = 'svg-status-available';
                break;
            case 4:
                svgclass = 'svg-status-deposit';
                break;
            case 3:
                svgclass = 'svg-status-hold';
                break;
            default:
                svgclass = 'svg-status-sold';
        }
        const dot_coords = element.sold_dot_position.split(",");
        return (
            <circle key={element.id} cx={dot_coords[0]} cy={dot_coords[1]} r={this.props.dotsize} className={svgclass}/>
        )
    }
    render() {
        return (
            <div className="landforsale-map_sold_status">
                <svg width={this.props.width} height={this.props.height}>
                    {this.props.elements.map(this.renderCircles)}
                </svg>
            </div>
        );
    }

}

export default planDisplay;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/PlanStatusDots.js
 **/